import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductDetailsComponent } from './products/product-details/product-details.component';
import { ProductLeftSidebarComponent } from './products/product-left-sidebar/product-left-sidebar.component';
import { HomeTwoComponent } from './home-two/home-two.component';
import { MainComponent } from '../main/main.component';
import { HomeComponent } from './home/home.component';

import { Resolver } from '../../modals/resolver'
import { ProductExpositorLeftSidebarComponent } from './products/product-expositor-left-sidebar/product-expositor-left-sidebar.component';
import { AdsComponent } from './products/ads/ads.component';


// Routes
const routes: Routes = [
  {
    path: '',
    children:[
      { path: '', component: HomeTwoComponent },
      { path: 'products/:expositor', component: ProductLeftSidebarComponent},
      { path: 'product/:id', component: ProductDetailsComponent },
      { path: 'expositor/:category', component: ProductExpositorLeftSidebarComponent},
      { path: 'clasificados', component: AdsComponent}
    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  declarations: [
  ],
})


export class ShopRoutingModule { }
